import * as actionTypes from './actionTypes'

const initialState = {
  count: 0,
  namePrefix: '',
  users: [],
  isUsersLoading: false,
  error: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.USERS_REQUESTED:
      return {
        ...state,
        isUsersLoading: true,
        error: null,
      }

    case actionTypes.USERS_SUCCEED:
      return {
        ...state,
        isUsersLoading: false,
        namePrefix: action.namePrefix,
        users: action.users,
      }

    case actionTypes.USERS_FAIL:
      return {
        ...state,
        isUsersLoading: false,
        error: action.error,
      }

    case actionTypes.UPDATE_USER:
      const updatedUsers = state.users || []
      const editedUser = action.user

      for (let i = 0; i < updatedUsers.length; i++) {
        if (updatedUsers[i].id === editedUser.id) {
          console.log('update candidate:')
          console.log(updatedUsers[i])

          updatedUsers[i] = editedUser

          console.log('new value:')
          console.log(updatedUsers[i])
        }
      }

      return {
        ...state,
        users: updatedUsers,
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/users/reducer.js